import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(theme => {
  const { spacing } = theme;
  return {
    smWebRespWebButton: ({ ctaColor }) => ({
      color: {
        sabaeus: '#00BF6F',
        concord: '#671E75',
        midnight: '#05467E',
      }[ctaColor],
      backgroundColor: '#fff',
      paddingLeft: spacing[5],
      paddingRight: spacing[5],
      border: 'none',
      '&:hover, &:focus': {
        backgroundColor: {
          sabaeus: '#bdf3dc',
          concord: '#dad1dc',
          midnight: '#a8c6e0',
        }[ctaColor],
      },
    }),
  };
});

export default useStyles;
